module.exports = __webpack_public_path__ + "static/img/gol.ec632ec9.png";